<ham-table
    [dataSource]="data"
    [pageSize]="5"
    (rowSelected)="onInsertTextSnippetClicked($event)"
    [alreadySelectedRow]="selectedRowTextSnippet"
>
    <ng-template hamHeaderCell hamTextCol>
        {{ 'aumico_annual_report_complementary_reports_text_snippets_dialog_description' | i18next }}</ng-template
    >
    <ng-template hamHeaderCell hamTextCol>
        {{ 'aumico_reports_organization_settings_text_snippets_list_title_column_header' | i18next }}</ng-template
    >
    <ng-template hamHeaderCell hamTextCol></ng-template>

    <ng-template hamCell let-element hamTextCol> {{ element.description }} </ng-template>
    <ng-template hamCell let-element hamTextCol> {{ element.title }} </ng-template>
    <ng-template hamCell let-element hamTextCol>
        <div class="circle" [class.active]="selectedRowTextSnippet?._id === element._id"></div>
    </ng-template>
</ham-table>
